import { render } from "./CampaignListLayout.vue?vue&type=template&id=7584fde2&scoped=true"
import script from "./CampaignListLayout.vue?vue&type=script&lang=js"
export * from "./CampaignListLayout.vue?vue&type=script&lang=js"

import "./CampaignListLayout.vue?vue&type=style&index=0&id=7584fde2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7584fde2"]])

export default __exports__